// extracted by mini-css-extract-plugin
module.exports = {"header":"NotificationSettingsList_header__PNvZs"};